import { request } from '../api/client';

export interface InquirySalesPerson {
  id: string;
  name: string;
  mobile: string | null;
  latitude: number | null;
  longitude: number | null;
  locationSource: string;
  distanceMeters?: number | null;
  coversRetailer?: string;
}
export interface InquiryRetailer {
  id: string;
  name: string;
  contactPerson: string | null;
  mobile: string | null;
  whatsapp: string | null;
  city: string | null;
  address: string | null;
  latitude: number | null;
  longitude: number | null;
  distanceMeters: number | null;
  salesPerson: InquirySalesPerson | null;
}
export interface NearestResult {
  retailers: InquiryRetailer[];
  salesPersons: InquirySalesPerson[];
  radiusKm?: number;
  origin?: { lat: number; lng: number };
  byPincode?: boolean;
  /** The state the search was fenced to (resolved from the pincode). Echoed back on submit so the
   *  lead records the area the dealer was actually chosen in. */
  stateCode?: string | null;
}

export interface SubmitInquiryPayload {
  customerName: string;
  customerEmail?: string;
  customerPhone?: string;
  customerWhatsapp?: string;
  productId?: string;
  productNameText?: string;
  message?: string;
  latitude?: number;
  longitude?: number;
  accuracyMeters?: number;
  pincode?: string;
  city?: string;
  stateCode?: string;
  chosenRetailerId?: string;
  website?: string; // honeypot
}

export interface AvailableLocations {
  states: string[];
  cities: { city: string; stateCode: string }[];
  /** Set when a pincode narrowed the list to one state — the visitor’s own. */
  stateCode?: string | null;
}
/** Pass the pincode the visitor typed: the dropdowns then offer THEIR state, not the whole country. */
export const getLocations = (pincode?: string) =>
  request<AvailableLocations>({ url: '/public/inquiries/locations', params: pincode ? { pincode } : {} });
export const getByLocation = (state?: string, city?: string) =>
  request<NearestResult>({ url: '/public/inquiries/retailers', params: { state, city } });

export const getNearest = (lat: number, lng: number, radiusKm?: number) =>
  request<NearestResult>({ url: '/public/inquiries/nearest', params: { lat, lng, radiusKm } });

export const getNearestByPincode = (pincode?: string, city?: string, state?: string) =>
  request<NearestResult>({ url: '/public/inquiries/nearest-by-pincode', params: { pincode, city, state } });

export const submitInquiry = (payload: SubmitInquiryPayload) =>
  request<{ inquiryNo: string; publicToken: string; status: string; deduped?: boolean }>({
    url: '/public/inquiries', method: 'POST', data: payload,
  });

export const getInquiryStatus = (token: string) =>
  request<{ inquiryNo: string; status: string; productName: string | null; customerName: string; createdAt: string; contactedAt: string | null }>({
    url: `/public/inquiries/${token}`,
  });

export const fmtDistance = (m: number | null | undefined): string => {
  if (m == null) return '';
  return m < 1000 ? `${Math.round(m)} m` : `${(m / 1000).toFixed(1)} km`;
};
